import {computed, ref} from "vue";

const useUser = () => {

  // ユーザ
  const user = ref({
    id: 0,
    name: '',
    email: '',
    birthday: '',
    prefecture: '',
    tel: '',
    real_name: '',
    real_name_kana: '',
    zip: '',
    address: '',
    building: '',
    point: '',
    children_status: 0,
    is_public_children: 0,
    is_public_prefecture: 0,
    is_receive_mail_magazine: 0,
    interesting_other_reason: '',
    created_at: '',
    updated_at: '',
    deleted_at: '',
    public_children: [],
    public_prefecture: '',
  });

  // 住所データが空白でないか判定
  const isShipping = computed(() => user.value.tel !== '' &&
    user.value.real_name !== '' &&
    user.value.real_name_kana !== '' &&
    user.value.zip !== '' &&
    user.value.address !== '');

  // ユーザ情報の初期化
  const initUser = (data) => {
    user.value = {
      ...user.value,
      ...data,
    };
  };

  // 返す
  return {
    user,
    isShipping,
    initUser,
  };

};

//composition のエクスポート
export default useUser;

//composition を注入するためのキー
export const USE_SHIPPING_KEY = Symbol('useUser');
